export const cardNumberId = 'stripeCardNumberCont';
export const cardExpiryId = 'stripeCardExpiryCont';
export const cardCvcId = 'stripeCardCvcCont';
